import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorsToIgnore } from '../../helpers/http-errors-to-ignore.helper';
import { LogBuilderService } from '../local/log-builder.service';
import { LogService } from '../log.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private _logBuilderService: LogBuilderService,
    private _logService: LogService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError(error => {
      if (error.status) {
        if (!HttpErrorsToIgnore.includes(error.status)) {
          const newErrorLog = this._logBuilderService.build(error);
          this._logService.insert(newErrorLog).subscribe();
        }
      }
      return throwError(error);
    }));
  }
}
